import React, { Component } from 'react';

class PrintWarrantyConfirmation extends Component {

    render() {
        const { customer, data } = this.props;

        const now = new Date();

        const month = String(now.getMonth() + 1).padStart(2, '0'); // 01–12
        const year = now.getFullYear(); // 2026

        return (
            <div className="print-page">

                {/* Quốc hiệu */}
                <div className="header">
                    <div className="header-left">
                        Công ty TNHH Anh Nguyễn Beauty
                        <br />
                        Cơ sở KB, CB: Nha khoa CHINGO
                    </div>

                    <div className="header-center">
                        <div className="fw-bold uppercase">
                            CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                        </div>
                        <div className="national-sub">
                            Độc lập - Tự do - Hạnh phúc
                        </div>
                    </div>

                    <div className="header-right"></div>
                </div>

                {/* Tiêu đề */}
                <div className="text-center fw-bold uppercase mt-32" style={{ fontSize: 18 }}>
                    GIẤY XÁC NHẬN BẢO HÀNH & GIỚI HẠN TRÁCH NHIỆM
                </div>

                {/* I. Thông tin bảo hành */}
                <div className="mt-10 fw-bold">I. THÔNG TIN BẢO HÀNH</div>

                <ul>
                    <li>Khách hàng: .................................................................</li>
                    <li>Dịch vụ: .................................................................</li>
                    <li>Số răng: .................................................................</li>
                    <li>
                        Thời hạn bảo hành:
                        .................................................
                        <span style={{ fontStyle: 'italic' }}>
                            &nbsp;(theo chính sách phòng khám)
                        </span>
                    </li>
                </ul>

                {/* II. Phạm vi bảo hành */}
                <div className="mt-10 fw-bold">II. PHẠM VI BẢO HÀNH</div>

                <div className="mt-10">
                    Bảo hành áp dụng cho:
                </div>

                <ul>
                    <li>Lỗi kỹ thuật do phòng khám</li>
                    <li>Lỗi vật liệu trong điều kiện sử dụng bình thường</li>
                </ul>

                {/* III. Không được bảo hành */}
                <div className="mt-10 fw-bold">III. CÁC TRƯỜNG HỢP KHÔNG ĐƯỢC BẢO HÀNH</div>

                <div className="mt-10">
                    Bao gồm nhưng không giới hạn:
                </div>

                <ul>
                    <li>Bong, vỡ do tai nạn, va chạm</li>
                    <li>Ăn nhai vật cứng, nghiến răng</li>
                    <li>Không tái khám định kỳ theo chỉ định</li>
                    <li>Can thiệp tại cơ sở nha khoa khác</li>
                </ul>

                {/* IV. Xác nhận hiểu rõ */}
                <div className="mt-10 fw-bold">IV. XÁC NHẬN HIỂU RÕ</div>

                <div className="mt-10">
                    Tôi xác nhận đã:
                </div>

                <ul>
                    <li>Được giải thích rõ điều kiện bảo hành</li>
                    <li>Hiểu và đồng ý với các giới hạn trách nhiệm</li>
                    <li>Không khiếu nại ngoài phạm vi bảo hành</li>
                </ul>

                {/* Ký xác nhận */}
                <div className="mt-16 fw-bold text-right">
                    Khách hàng ký xác nhận
                </div>
                <div className="text-right">
                    (Ký - ghi rõ họ tên - ngày …… / …… / …… )
                </div>



                <style>
                    {`
                        @page {
                            size: A4;
                            margin: 1cm 1.2cm 1cm 1.8cm;
                            /* top, right, bottom, left */
                        }

                        @media print {
                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 14pt;
                                line-height: 1.5;
                                color: #000;
                            }

                            .print-page {
                                width: 100%;
                            }

                            .text-center {
                                text-align: center;
                            }

                            .text-right {
                                text-align: right;
                            }

                            .fw-bold {
                                font-weight: bold;
                            }

                            .uppercase {
                                text-transform: uppercase;
                            }

                            .mt-10 { margin-top: 10px; }
                            .mt-16 { margin-top: 16px; }
                            .mt-24 { margin-top: 24px; }
                            .mt-32 { margin-top: 32px; }

                            ul {
                                margin: 5px 0 5px 20px;
                                padding-left: 10px;
                            }

                            li {
                                margin-bottom: 5px;
                            }
                            
                            /* HEADER TỔNG */
                            .header {
                                display: grid;
                                grid-template-columns: 0.8fr 2fr 0.8fr;
                                align-items: start;
                                margin-bottom: 16px;
                            }

                            /* CỘT TRÁI */
                            .header-left {
                                font-size: 11pt;      /* nhỏ hơn body */
                                line-height: 1.3;
                                text-align: left;
                            }

                            /* CỘT GIỮA – QUỐC HIỆU */
                            .header-center {
                                font-size: 12pt;      /* nhỏ hơn body (14pt) */
                                line-height: 1.35;
                                text-align: center;
                            }

                            /* Gạch dưới khẩu hiệu */
                            .header-center .national-sub {
                                display: inline-block;
                                padding-bottom: 2px;
                                border-bottom: 1px solid #000;
                            }

                            /* RIGHT */
                            .header-right {
                                /* để trống để cân bố cục */
                            }
                        }

                    `}
                </style>
            </div >
        );
    }
}

export default PrintWarrantyConfirmation;
